import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  title = 'st-app-ui';
  /*
  links = [
    {
      label: 'Home',
      path: '/app/home',
      requiresLogin: true,
      role: ['USER', 'HELPDESK']
    },
    {
      label: 'Reports',
      path: '/app/reports',
      requiresLogin: true,
      role: ['USER', 'HELPDESK']
    }
  ]*/
  homeFrontPage = 'https://email.scalanthropy.com';

  goToHomePage(): void {
    window.open(this.homeFrontPage, '_blank');
  }
}
